import React from 'react';
import { GameGridFilterByEnum as FilterBy } from '../../../../../shared/src/enums/game-grid-filter-by.enum';
import { SubcategoriesFilterActionProviders } from '../SubcategoriesFilterActionProviders';

export const SubcategoriesFilterActionSection = ({
    option,
    values,
    onOptionClick,
    currentSubcategory,
}) => {
    if (option === FilterBy.PROVIDERS) {
        return <SubcategoriesFilterActionProviders
            selectedOptions={values}
            onOptionClick={onOptionClick}
            currentSubcategory={currentSubcategory}
        />;
    }
    return null;
};
